import { gql } from 'apollo-angular';

export var subscribe_to_sequence = gql`
  mutation SUBSCRIBE_TO_SEQUENCE($input: StatusSequenceSubscriptionInput!) {
    subscribeToStatusSequence(input: $input) {
      id
      statusSequence {
        id
        name
      }
      project {
        pipelineProjects {
          id
          active
          pipelineProjectDates {
            id
            date
            initial_target
            target
            pipelineMilestone {
              id
              milestone {
                name
              }
              milestoneStatus {
                id
              }
            }
          }
          pipeline {
            name
          }
        }
        projectStatuses {
          id
          is_primary
          active
          status {
            id
            name
          }
          statusSequence {
            id
            name
            status_sequence_details {
              index
              status {
                id
                name
              }
              milestoneStatus {
                id
                pipeline_milestone_id
              }
            }
          }
        }
      }
    }
  }
`;

export var activate_sequence = gql`
  mutation ACTIVATE_SEQUENCE($id: ID!, $active: Boolean!) {
    updateStatusSequence(id: $id, active: $active) {
      id
      statusSequence {
        id
        name
      }
      project {
        pipelineProjects {
          id
          active
          pipelineProjectDates {
            id
            date
            initial_target
            target
            pipelineMilestone {
              id
              milestone {
                name
              }
              milestoneStatus {
                id
              }
            }
          }
          pipeline {
            name
          }
        }
        projectStatuses {
          id
          is_primary
          active
          status {
            id
            name
          }
          statusSequence {
            id
            name
            status_sequence_details {
              index
              status {
                id
                name
              }
              milestoneStatus {
                id
                pipeline_milestone_id
              }
            }
          }
        }
        applications {
          id
          amount_requested
          request_date
          awarded
          project_id
          taxCreditType {
            level
            name
          }
          taxCreditDesignation {
            name
          }
          fundingRound {
            id
            year
            number
            name
            due_date
            award_date
            organization {
              id
              name
            }
            state {
              name
            }
          }
          organization {
            id
            name
          }
          person {
            id
            name
          }
        }
      }
    }
  }
`;

export var update_status = gql`
  mutation UPDATE_STATUS($id: ID!, $status_id: ID!, $status_sequence_id: ID!) {
    updateStatus(
      id: $id
      status_id: $status_id
      status_sequence_id: $status_sequence_id
    ) {
      id
      is_primary
      active
      statusSequence {
        id
        name
      }
      projectSubstatuses {
        id
        project_status_id
        subsequence_id
        substatus_id
      }
      projectSubstatusDates {
        id
        project_status_id
        subsequence_id
        substatus_id
        date
        utc_time
        timezone
        target
      }
      status {
        id
        name
      }
      project {
        pipelineProjects {
          id
          active
          pipelineProjectDates {
            id
            date
            initial_target
            target
            pipelineMilestone {
              id
              milestone {
                name
              }
              milestoneStatus {
                id
              }
            }
          }
          pipeline {
            name
          }
        }
        projectStatuses {
          id
          is_primary
          active
          status {
            id
            name
          }
          statusSequence {
            id
            name
            status_sequence_details {
              index
              status {
                id
                name
              }
              milestoneStatus {
                id
                pipeline_milestone_id
              }
            }
          }
        }
        applications {
          id
          amount_requested
          request_date
          awarded
          project_id
          taxCreditType {
            level
            name
          }
          taxCreditDesignation {
            name
          }
          fundingRound {
            id
            year
            number
            name
            due_date
            award_date
            organization {
              id
              name
            }
            state {
              name
            }
          }
          organization {
            id
            name
          }
          person {
            id
            name
          }
        }
      }
    }
  }
`;

export var update_pipeline_project = gql`
  mutation UPDATE_PIPELINE_PROJECT($input: UpdatePipelineProject) {
    updatePipelineProject(input: $input) {
      id
      project {
        pipelineProjects {
          id
          pipelineProjectDates {
            id
            date
            initial_target
            target
            pipelineMilestone {
              id
              pipeline {
                id
                name
              }
              milestone {
                id
                name
              }
              milestoneStatus {
                id
                pipeline_milestone_id
                statusSequenceDetail {
                  id
                  index
                  status {
                    id
                    name
                  }
                  statusSequence {
                    id
                    name
                  }
                }
              }
            }
          }
          pipeline {
            id
            name
          }
        }
      }
    }
  }
`;

export var update_pipeline_project_and_forecast_approvals = gql`
  mutation UPDATE_PIPELINE_PROJECT_AND_FORECAST_APPROVALS(
    $input: UpdatePipelineProject
    $forecast: UpdateForecastApprovals
    $projectID: ID!
  ) {
    updatePipelineProject(input: $input) {
      id
      project {
        pipelineProjects {
          id
          pipelineProjectDates {
            id
            date
            initial_target
            target
            pipelineMilestone {
              id
              pipeline {
                id
                name
              }
              milestone {
                id
                name
              }
              milestoneStatus {
                id
                pipeline_milestone_id
                statusSequenceDetail {
                  id
                  index
                  status {
                    id
                    name
                  }
                  statusSequence {
                    id
                    name
                  }
                }
              }
            }
          }
          pipeline {
            id
            name
          }
        }
      }
    }
    updateProjectMilestoneDates(input: $forecast) {
      id
      projectMilestoneDates(project_id: $projectID) {
        id
        date
        dateType {
          id
          name
        }
        pipelineMilestone {
          id
        }
      }
    }
  }
`;

export var update_forecast_approvals = gql`
  mutation UPDATE_FORECAST_APPROVALS(
    $input: UpdateForecastApprovals
    $projectID: ID!
  ) {
    updateProjectMilestoneDates(input: $input) {
      id
      projectMilestoneDates(project_id: $projectID) {
        id
        date
        dateType {
          id
          name
        }
        pipelineMilestone {
          id
        }
      }
    }
  }
`;

export var delete_pipeline_project_date = gql`
  mutation DELETE_PIPELINE_PROJECT_DATE($id: ID!) {
    deletePipelineProjectDate(id: $id) {
      id
    }
  }
`;
